GatiServerGame = function () {
  var base = new GatiServer();
  GatiServer.call(this, base);
  this.inFS = false;
  this.fsIndex = 0;
  this.fsWinnings = 0;
  this._finalFsWinnings = 0;
  this.fsCount = 0;

  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;
  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.restorePreviousWagersBase = this.restorePreviousWagers;
  this.restorePreviousWagers = this.restorePreviousWagersDerived;
  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this._inBuyABonus = false;
  this._inLuckyBet = false;
  this.defaultPersistanceData = undefined;

  this.playerState = undefined;
  this.initialPlayerState = undefined;

  this.cloverProgressCount = undefined;
  this.cloverActivationCount = undefined;

  this.freeSpinsCostMultiplierLow;
  this.freeSpinsCostMultiplierMed;
  this.freeSpinsCostMultiplierHigh;

  this.buyBonusMedActive = false;
  this.buyBonusHighActive = false;

  this.luckyBetCostMultiplier;

  this._totalWinnings = 0;
  this._finalBaseWinnings = 0;

  //this.loadLanguageFiles = undefined; // delete me when translations are ready

  this.force = undefined;

  this._persistentValues = {};

  this.currentMode = "Basic";
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);

GatiServerGame.prototype.getRandomForGui = function () {
  let rangeExplicit = 32768; // it is the default inside the mersenneTwister but in case they change it I am defining it here
  let r = MarsenneTwister.rand(rangeExplicit);
  let res = r / rangeExplicit;
  return res;
};

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    undefined,
    "LEFT_TOP",
    ["playerState"]
  );
};

GatiServer.prototype.addCoinResult = function (event) {
  var message = event;
  message.type = "game:coinResultEvent";
  this._messageQueue.push(message);
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController("stakeController");
    const maxStake = sc.isMaxStake();
    if (sc.isMaxStake() && !this._inReplayMode && !this._inRewatchMode && !this._isPrePaidGame) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServer.prototype.requestNextSpinOutcome = function (cb) {
  this.logCheatString();
  let outcome = this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.response.clientData;
  this.playerState = this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.playerState;
  this.initialPlayerState =
    this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.initialPlayerState !== undefined
      ? this._latestEngineReponse.wager.bets[this._currentBetData].eventdata.initialPlayerState
      : this.defaultPersistanceData;
  if (this.cheatPanelActive) {
    this.cheat = this._latestEngineReponse.wager.bets[this._currentBetData].betdata.cheat;
  }
  if (this.force !== "" && !this.inFS) {
    this.updateInitialPlayerStateFromCheatString();
  }
  this.getSpinData(cb, outcome, this.playerState, this.initialPlayerState);
};

GatiServerGame.prototype.setBPL = function (bpl) {
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;
  if (gameData.encoreEnabled) {
    newStake *= 1.5;
  }

  this.updateCurrentStake(newStake);
};

GatiServerGame.prototype.restorePreviousWagersDerived = function () {
  const isLuckyBet = this._previousWagers.data[0].bets[0].betdata.cmd === "LUCKYBET_BUY";
  if (this._previousWagers.data[0].bets[0].betdata.cmd === "LUCKYBET_BUY") {
    this._coinValue = 100;
  } else {
    this._coinValue = 10;
  }
  let res = this.restorePreviousWagersBase();

  //why is res.baseStake 10* higher on rapid riches but not on paddys (for luckybet)?
  res.baseStake = res.baseStake / (isLuckyBet ? 10 : 1);

  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === "LUCKYBET_BUY"
  ) {
    this.setDefaultBet(res.baseStake);
  }
  return res;
};

GatiServer.prototype.clientReadyToStart = function (cbWhenPlatformReady) {
  var self = this;
  const informGameReady = async (slot) => {
    var readyResponse = await slot.getGameEventsEmitter().gameReady({ defaultBetValue: this._stake / 100 });
    console.log("Gati Platform: Restore Mode set to " + readyResponse.restoreMode);
    // no longer modal
    messageBus.post("game:modal", {});
    self._finishedLoading = true;
    self._isRecoveryGame = readyResponse.restoreMode === "RESTORE";
    if (self._inRewatchMode || self._inReplayMode || self._isRecoveryGame) {
      gdk.startMinGameTimer(); // we bypass start during recovery so the gdk wont do this for us
      self._isPrePaidGame = true; // Tells setBPL not to show max stake popup, this is a recover game they have already seen this popup
      let stakeInfo = self.restorePreviousWagers();
      self._isPrePaidGame = slot.getWagerHelper().getPrepaidInfo().isPrepaid; //prepaids has a very specifice purpose and this isnt it, so put it back!
      self.initNewGame({ stake: stakeInfo.stake, bpl: stakeInfo.baseStake / self._numLines }, self._isRecoveryGame);

      // now initGame no longer sends balance out because PokerStars doesnt want to the debit until
      // a result has been received so there are no errors, we must do it explicitly in side rewatch/recover/replay
      self.addBalanceEventToQueue();
      self.triggerNextMessage();

      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      self._wagerId = self._latestEngineReponse.wager.wagerid;
      await this._slotGame.getGameEventsEmitter().gameRoundStarted();
      await this._slotGame.getGameEventsEmitter().spinStarted();
      self.addRecoveryToQueue();
      self.triggerNextMessage();
      cbWhenPlatformReady();
      messageBus.postImmediate("common:GameCommitted");
    } else if (readyResponse.restoreMode === "SKIP") {
      self.restorePreviousWagers();
      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      const finalIndex = this._previousWagers.data[0].bets.length - 1;
      const initialPlayerState =
        this._previousWagers.data[0].bets[finalIndex].eventdata.initialPlayerState !== undefined
          ? this._previousWagers.data[0].bets[finalIndex].eventdata.initialPlayerState
          : this.defaultPersistanceData;
      const playerState = this._previousWagers.data[0].bets[finalIndex].eventdata.playerState;
      if (playerState !== undefined) {
        this.updatePersistentState(initialPlayerState, playerState, this.currentMode);
        this.restoreCounterData(playerState);
      }
      await self.handleSkipWin(self._latestEngineReponse);
      let win = await self.doCollectWinnings();
      gameData.winningsMeter.set(win);
      await self._slotGame.getGameEventsEmitter().gameRoundEnded();
      self._oldBalance = self._balance;
      self._preCommitBalance = self._balance;
      self.addBalanceEventToQueue();
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);
      self.triggerNextMessage();
      cbWhenPlatformReady();
    } else {
      let license = this._license;
      if (license === "" || license === undefined) {
        license = "default";
      } else {
        license = license.toUpperCase();
      }

      // Brazil specific, show help page if the game is not in replay mode and the license is BR
      if (license === "BR") {
        gameData.helpPageScroll.open();
      }

      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);

      if (gameData.previousStakeAndMode?.previousBasicStake != null) {
        if (gameData.previousStakeAndMode?.lastGameMode === 0 || gameData.previousStakeAndMode?.lastGameMode === 1) {
          self.changeStake(gameData.previousStakeAndMode?.previousBasicStake);
        }
      }

      cbWhenPlatformReady();
    }
  };

  // stop game interaction just in case the recovery popup will show (we dont know until we have a response from gameReady)
  messageBus.post("game:modal", {
    reason: "Waiting on Platform",
  });

  informGameReady(this._slotGame);
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  this.isRestore = loadData.mode === "RESTORE";
  this.addGameConfigToQueueBase(loadData);
  this.defaultPersistanceData =
    loadData.settings.gameFeatures !== undefined &&
    loadData.settings.gameFeatures.playerState !== undefined &&
    loadData.settings.gameFeatures.playerState.playerState !== undefined
      ? loadData.settings.gameFeatures.playerState.playerState
      : this.defaultPersistanceData;

  this.cheatPanelActive = loadData.customParameters.cheatPanel === "yes";

  let configMessage = this._messageQueue[this._messageQueue.length - 1];

  gameData.recoveryStake = undefined;
  configMessage.maxExposure = loadData.settings.slotConfig.MaxExposure;

  if (configMessage.slotConfig.gameModes.BONUS_BUY_LOW) {
    this.freeSpinsCostMultiplierLow = configMessage.slotConfig.gameModes.BONUS_BUY_LOW.coinsPerBet / 10;
  }

  if (configMessage.slotConfig.gameModes.BONUS_BUY_MED) {
    this.freeSpinsCostMultiplierMed = configMessage.slotConfig.gameModes.BONUS_BUY_MED.coinsPerBet / 10;
  }

  if (configMessage.slotConfig.gameModes.BONUS_BUY_HIGH) {
    this.freeSpinsCostMultiplierHigh = configMessage.slotConfig.gameModes.BONUS_BUY_HIGH.coinsPerBet / 10;
  }

  configMessage.slotConfig.coins = 10; // purely paytable
  configMessage.slotConfig.winlineValue = 10; // purely paytable

  configMessage.slotConfig.inReplayMode = this._inReplayMode;

  gameData.inReplayOrWatch = this._inReplayMode || this._inRewatchMode;

  gameData.megaPotValue = configMessage.slotConfig.pots.mega;
  gameData.majorPotValue = configMessage.slotConfig.pots.major;
  gameData.minorValue = configMessage.slotConfig.pots.minor;
  gameData.miniValue = configMessage.slotConfig.pots.mini;
  gameData.winlineValue = configMessage.slotConfig.winlineValue;

  this.luckyBetCostMultiplier = configMessage.slotConfig.gameModes.LUCKYBET_BUY.coinsPerBet;

  configMessage.buyBonusCostFreeSpinsLow = this.freeSpinsCostMultiplierLow;
  configMessage.buyBonusCostFreeSpinsMed = this.freeSpinsCostMultiplierMed;
  configMessage.buyBonusCostFreeSpinsHigh = this.freeSpinsCostMultiplierHigh;

  configMessage.buyLuckyBet = this.luckyBetCostMultiplier;

  gameData.recoveryStake = undefined;

  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);

    gameData.recoveryStake = stake;
    gameData.bonusRecovery = false;

    if (betData.cmd === "LUCKYBET_BUY") {
      gameData.recoveryStake *= 1.5;
      gameData.recoveryMode = "LUCKYBET_BUY";
    } else if (betData.cmd === "BONUS_BUY_LOW") {
      gameData.recoveryMode = "BONUS_BUY_LOW";
      gameData.bonusRecovery = true;
    } else if (betData.cmd === "BONUS_BUY_MEDIUM") {
      gameData.recoveryMode = "BONUS_BUY_MEDIUM";
      gameData.bonusRecovery = true;
    } else if (betData.cmd === "BONUS_BUY_HIGH") {
      gameData.recoveryMode = "BONUS_BUY_HIGH";
      gameData.bonusRecovery = true;
    }
  }

  if (configMessage.slotConfig.gameModes["BONUS_BUY_LOW"] || configMessage.slotConfig.gameModes["LUCKYBET_BUY"]) {
    allowBonusBuy = true;
  }
  gameController.license = loadData.customParameters.license;
  if (
    loadData.customParameters.buyBonusDisabled === "yes" ||
    loadData.customParameters.buyBonusDisabled === "Yes" ||
    loadData.customParameters.license === "uk" ||
    loadData.customParameters.license === "fin" ||
    loadData.customParameters.license === "lt" ||
    loadData.customParameters.license === "nl" ||
    loadData.customParameters.license === "de" ||
    loadData.customParameters.license === "CZ"
  ) {
    allowBonusBuy = false;
  }

  let persistentState;

  if (this._inRewatchMode || this._inReplayMode || loadData.mode === "RESTORE") {
    let bets = loadData.wagers.data[0].bets;
    for (let i = 0; i < bets.length; ++i) {
      let bet = bets[i];
      if (bet.eventdata && bet.eventdata.initialPlayerState) {
        persistentState = JSON.parse(bet.eventdata.initialPlayerState.state);
        persistentState.LastCashBasicStake =
          bet.eventdata.response.clientData.BasicStake ?? persistentState.LastCashBasicStake;
        break;
      }
    }
  } else if (loadData.settings.gameFeatures.playerState.playerState !== undefined) {
    persistentState = JSON.parse(loadData.settings.gameFeatures.playerState.playerState.state);
  } // else it will use the default amounts below, which get updated in updatePersistentValue if we have them previously

  let defaultNewPlayerActivationCount =
    loadData.settings.slotConfig.Config["spinner:GameConfigEvent"].slotConfig.newPlayerActivationCount;

  let defaultNewPlayerCloverCount =
    loadData.settings.slotConfig.Config["spinner:GameConfigEvent"].slotConfig.newPlayerCloverCount;

  let defaultMode = 0;

  this._currency = loadData.settings.currency;

  let gameModeStrings = ["Basic", "LuckyBet", "BonusBuyLow", "BonusBuyMedium", "BonusBuyHigh", "Basic"];
  let gameModes = [];
  for (let i = 0; i < Object.keys(configMessage.slotConfig.gameModes).length; ++i) {
    gameModes.push(Object.keys(configMessage.slotConfig.gameModes)[i]);
    this._persistentValues[gameModeStrings[i]] = {};
  }

  let totalStakes = [];
  for (let i = 0; i < configMessage.slotConfig.coinSizes.length; ++i) {
    totalStakes.push(configMessage.slotConfig.coinSizes[i]);
  }

  for (let i = 0; i < gameModes.length; ++i) {
    let gameMode = gameModeStrings[i];

    for (let i = 0; i < totalStakes.length; ++i) {
      let totalStake = totalStakes[i];

      this._persistentValues[gameMode]["Stake_" + totalStake] = {
        playerActivationCount: defaultNewPlayerActivationCount,
        cloverCount: defaultNewPlayerCloverCount,
      };
      if (persistentState !== undefined) {
        this.updatePersistentValue(totalStake, persistentState, gameMode);
      }
    }
  }
  let gcMessage = this._messageQueue[this._messageQueue.length - 1];
  if (persistentState !== undefined && persistentState.LastGameMode !== undefined) {
    if (loadData.settings.isGoldenBetDisabled && persistentState.LastGameMode === 1) {
      persistentState.LastGameMode = 0;
      gameController.isGoldenbetNowInvalid = true;
    }
    configMessage.slotConfig.LastGameMode = persistentState.LastGameMode;
    gcMessage.LastGameMode = persistentState.LastGameMode;
  } else {
    configMessage.slotConfig.LastGameMode = defaultMode;
    gcMessage.LastGameMode = defaultMode;
  }
  configMessage.slotConfig.persistentValues = this._persistentValues;
  gdk.addConfigValue("AllowBuyBonus", allowBonusBuy ? true : false);

  if (persistentState) {
    gameData.previousStakeAndMode = {
      previousBasicStake: persistentState.LastCashBasicStake,
      lastGameMode: persistentState.LastGameMode,
    };
  }
};

GatiServerGame.prototype.updatePersistentValue = function (stake, state, mode) {
  if (state.CloverProgress.hasOwnProperty(mode)) {
    if (state.CloverProgress[mode].hasOwnProperty(stake)) {
      if (Object.keys(this._persistentValues[mode]).includes("Stake_" + stake, 0)) {
        if (stake === 100) {
          if (gameData.slotConfig !== undefined) {
          }
        }
        this._persistentValues[mode]["Stake_" + stake].playerActivationCount =
          state.CloverProgress[mode][stake].ActivationCount;
        this._persistentValues[mode]["Stake_" + stake].cloverCount = state.CloverProgress[mode][stake].RespinsCount;
      }
    }
  }
};

GatiServerGame.prototype.updatePersistentState = function (initState, playerState, mode) {
  let gameModeStrings = ["Basic", "LuckyBet", "BonusBuyLow", "BonusBuyMedium", "BonusBuyHigh"];

  if (initState !== undefined) {
    let initialState = JSON.parse(initState.state);
    for (let i = 0; i < gameModeStrings.length; i++) {
      if (initialState.CloverProgress.hasOwnProperty(gameModeStrings[i])) {
        let stake = initialState.LastCashBasicStake;
        this.updatePersistentValue(stake, initialState, gameModeStrings[i]);
      }
    }
  }
  if (playerState !== undefined) {
    let newState = JSON.parse(playerState.state);

    for (let i = 0; i < gameModeStrings.length; i++) {
      if (newState.CloverProgress.hasOwnProperty(gameModeStrings[i])) {
        let stake = newState.LastCashBasicStake;
        this.updatePersistentValue(stake, newState, gameModeStrings[i]);
      }
    }
  }
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === "LUCKYBET_BUY") {
      this._inLuckyBet = true;
      gameData.encoreEnabled = true;

      this._meta = {
        name: "encore",
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === "BONUS_BUY_LOW") {
      this._inBuyABonus = true;
      this._meta = {
        name: "buyABonusLow",
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === "BONUS_BUY_MED") {
      this.buyBonusMedActive = true;
      this.buyBonusHighActive = false;
      this._inBuyABonus = true;
      this._meta = {
        name: "buyABonusMed",
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === "BONUS_BUY_HIGH") {
      this.buyBonusMedActive = false;
      this.buyBonusHighActive = true;
      this._inBuyABonus = true;
      this._meta = {
        name: "buyABonusHigh",
        value: true,
      };
      break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._inBuyABonus = stakeData.metaData.buyABonus;
  this._inLuckyBet = stakeData.metaData.encore;
  this.buyBonusMedActive = false;
  this.buyBonusHighActive = false;

  if (stakeData.metaData.buyBonusMedActive) {
    this.buyBonusMedActive = true;
  } else {
    this.buyBonusMedActive = false;
  }

  if (stakeData.metaData.buyBonusHighActive) {
    this.buyBonusHighActive = true;
  } else {
    this.buyBonusHighActive = false;
  }

  if (this._forces === undefined || !this._forces) {
    this._forces = "";
    this.addCheatToRequest(stakeData, this._forces);
  }

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  this._coinValue = 10;
  let stakeController = resourceManager.getController("stakeController");
  let baseStake = stakeController.getBaseStake("default") / 100;

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  this.currentMode = "Basic";

  if (this._forces === "" && this.cheatPanelActive) {
    request.cheat = JSON.stringify(null);
  }

  if (this._inLuckyBet) {
    //this._coinValue = 100; // has to be whole number
    request.amount = baseStake * 1.5;
    request.coin = baseStake / this._coinValue;
    request.coins = this.luckyBetCostMultiplier;
    this.currentMode = "LuckyBet";
    request.cmd = "LUCKYBET_BUY";
  } else if (this._inBuyABonus) {
    if (this.buyBonusMedActive) {
      baseStake = stakeController.getBaseStake("BONUS_BUY_MED") / 100;
      request.coins = this.freeSpinsCostMultiplierMed;
      request.amount = baseStake * this.freeSpinsCostMultiplierMed;
      this.currentMode = "BonusBuyMedium";
      request.cmd = "BONUS_BUY_MED";
    } else if (this.buyBonusHighActive) {
      baseStake = stakeController.getBaseStake("BONUS_BUY_HIGH") / 100;
      request.coins = this.freeSpinsCostMultiplierHigh;
      request.amount = baseStake * this.freeSpinsCostMultiplierHigh;
      this.currentMode = "BonusBuyHigh";
      request.cmd = "BONUS_BUY_HIGH";
    } else {
      baseStake = stakeController.getBaseStake("BONUS_BUY_LOW") / 100;
      request.coins = this.freeSpinsCostMultiplierLow;
      request.amount = baseStake * this.freeSpinsCostMultiplierLow;
      this.currentMode = "BonusBuyLow";
      request.cmd = "BONUS_BUY_LOW";
    }

    request.coin = baseStake / this._coinValue;
  }
};

GatiServerGame.prototype.addFSStartToQueue = function (numFs, initialFs) {
  this.fsWinnings = 0;
  var message = {};
  message.type = "spinner:FreeSpinsStartEvent";
  message.freeSpinsAwarded = initialFs;
  message.bonusWin = 0;
  message.currentMultiplier = 1;
  message.nextMultiplier = 2;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSDataToQueue = function () {
  let message = {};
  message.type = "spinner:FreeSpinsDataEvent";
  message.num = this.fsCount + 1;
  message.fsWinnings = this.fsWinnings;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSEndToQueue = function (winnings, isCapped) {
  let message = {};
  message.type = "spinner:FreeSpinsEndEvent";
  message.fsWinnings = this._finalFsWinnings;
  message.totalWinnings = this._totalWinnings;
  message.isBigWin = false;
  message.isCapped = isCapped;
  this.fsWinnings = 0;
  this.inFS = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.shuffleArray = function (array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
};

GatiServerGame.prototype.getSpinData = function (cb, data, playerState, initialPlayerState) {
  let parts = data.Parts;
  this._forces = "";
  this.UIRandomSeed = data.UIRandomSeed;

  if (this.inFS) {
    this.getSpinDataFS(parts[0], cb);
    return;
  } else {
    if (this.isRestore) {
      //create stake change message with initialPlayerState
      this.isRestore = false;
      this.restoreCounterData(initialPlayerState);
    }
    this.updatePersistentState(initialPlayerState, playerState, this.currentMode);
    let state = this._persistentValues["Stake_" + this._stake];
  }

  let totalWon = 0;
  for (let i = 0; i < parts.length; ++i) {
    let type = parts[i].type;
    if (type === "baseGame") {
      this._finalBaseWinnings = parts[0].winAmount;
      totalWon += this.getSpinDataNormal(parts[i]);
      this.getCoin;
      // base game only, game complete
      if (parts.length === 1) {
        this.addGameCompleteToQueue(totalWon);
      }

      let gcMessage = this._messageQueue[this._messageQueue.length - 1];
      gcMessage.persistentValues = this._persistentValues;
    } else if (type === "freeSpins") {
      //this.addFSAwardToQueue(parts[i].spins.length);
      this.inFS = true;
      this.fsCount = 0;
      this.freeSpins = parts[i].spins;
      this._finalFsWinnings = data.Parts[i].winAmount;
      this._totalWinnings = this._finalBaseWinnings + this._finalFsWinnings;
      this.addFSStartToQueue(parts[i].spins.length, parts[i].initialNumberOfSpins);
    }
  }

  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.restoreCounterData = function (initialPlayerState) {
  var message = initialPlayerState;
  message.type = "game:restoreCountersEvent";
  this._messageQueue.push(message);
};

GatiServerGame.prototype.processModifiers = function (data, spinEvent) {};

GatiServerGame.prototype.addModifiersToQueue = function (data, cloneReal) {};

GatiServerGame.prototype.hasModifier = function (data) {};

GatiServerGame.prototype.removeWildsFromReels = function (reels) {
  const wildId = 9;
  for (let reel = 0; reel < reels.length; ++reel) {
    for (let i = 0; i < reels[reel].symbols.length; ++i) {
      if (reels[reel].symbols[i].value === wildId) {
        reels[reel].symbols[i].value = 0;
      }
    }
  }
};

GatiServerGame.prototype.removeWildsFromAboveBelow = function (message) {
  this.removeWildsFromReels(message.resultPanel.symbolsAbove);
  this.removeWildsFromReels(message.resultPanel.symbolsBelow);
};

GatiServerGame.prototype.addFSSpinDataToQueue = function (
  event,
  coinAwardsAfterGoldenSpins,
  coinAwardsBeforeGoldenSpins,
  coins,
  goldenSpins,
  goldenSpinsMeterAtEnd,
  winAmountSoFar,
  anticipationTriggered
) {
  var message = {};
  message.type = "spinner:SpinEvent";

  message.lines = event.lines;
  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.totalWinnings = event.totalWinnings;
  message.resultPanel = {};
  message.resultPanel.reels = 5;
  message.UIRandomSeed = this.UIRandomSeed;

  message.coinAwardsAfterGoldenSpins = coinAwardsAfterGoldenSpins;
  message.coinAwardsBeforeGoldenSpins = coinAwardsBeforeGoldenSpins;
  message.coins = coins;
  message.goldenSpins = goldenSpins;
  message.goldenSpinsMeterAtEnd = goldenSpinsMeterAtEnd;
  message.winAmountSoFar = winAmountSoFar;
  message.anticipationTriggered = anticipationTriggered;

  message.resultPanel.reelList = event.reelList;
  message.resultPanel.symbolsAbove = event.symbolsAbove;
  message.resultPanel.symbolsBelow = event.symbolsBelow;

  this._messageQueue.push(message);

  return message;
};

GatiServerGame.prototype.addSpinDataToQueue = function (
  event,
  coins,
  coinAwards,
  payWays,
  cloverRespins,
  anticipationTriggered,
  winCapped
) {
  var message = {};
  message.type = "spinner:SpinEvent";

  if (payWays.winAmount === 0) {
    message.lines = false;
  } else {
    message.lines = true;
  }

  message.winCapped = winCapped;
  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.UIRandomSeed = this.UIRandomSeed;
  message.isPrePaidGame = this._isPrePaidGame;

  if (payWays.winAmount !== undefined && coinAwards.winAmount !== undefined) {
    message.totalWinnings = payWays.winAmount + coinAwards.winAmount;
  } else if (coinAwards.winAmount !== undefined) {
    message.totalWinnings = coinAwards.winAmount;
  } else if (payWays.winAmount !== undefined) {
    message.totalWinnings = payWays.winAmount;
  }

  message.resultPanel = {};
  message.resultPanel.reels = 5;

  message.coins = coins;
  message.coinAwards = coinAwards;
  message.cloverRespins = cloverRespins;
  message.anticipationTriggered = anticipationTriggered;

  message.resultPanel.reelList = event.reelList;
  message.resultPanel.symbolsAbove = event.symbolsAbove;
  message.resultPanel.symbolsBelow = event.symbolsBelow;

  this._messageQueue.push(message);

  return message;
};

GatiServerGame.prototype.getSpinDataGeneric = function (spinEvent, data, freeSpinsActive, cb) {
  let isCapped = data.winCapped;
  for (let x = 0; x < data.coins.length; x++) {
    if (data.coins[x].type === "Bonus") {
      const reel = data.coins[x].coord.reel;
      const row = data.coins[x].coord.row;
      spinEvent.reelList[reel].symbols[row].value = 12;
    } else if (data.coins[x].type === "Pot") {
      const reel = data.coins[x].coord.reel;
      const row = data.coins[x].coord.row;
      spinEvent.reelList[reel].symbols[row].value = 19;
    }
  }

  const mysteryId = 13;
  for (let reel = 0; reel < spinEvent.symbolsAbove.length; ++reel) {
    for (let i = 0; i < spinEvent.symbolsAbove[reel].symbols.length; ++i) {
      if (spinEvent.symbolsAbove[reel].symbols[i].value === mysteryId) {
        spinEvent.symbolsAbove[reel].symbols[i].value = 0;
      }
    }
  }

  for (let reel = 0; reel < spinEvent.symbolsBelow.length; ++reel) {
    for (let i = 0; i < spinEvent.symbolsBelow[reel].symbols.length; ++i) {
      if (spinEvent.symbolsBelow[reel].symbols[i].value === mysteryId) {
        spinEvent.symbolsBelow[reel].symbols[i].value = 0;
      }
    }
  }

  GatiServerGame.prototype.swapSymbolsForSizedVariants(spinEvent, data.coins);

  let payWays = data.payWays;

  if (!freeSpinsActive) {
    let coins = data.coins;
    let coinAwards = data.coinAwards;
    let cloverRespins = data.respins;
    let anticipationTriggered = data.anticipationTriggered;
    this.addSpinDataToQueue(spinEvent, coins, coinAwards, payWays, cloverRespins, anticipationTriggered, isCapped);
  } else {
    let anticipationTriggered = data.anticipationTriggered;
    let coinAwardsAfterGoldenSpins = data.coinAwardsAfterGoldenSpins;
    let coinAwardsBeforeGoldenSpins = data.coinAwardsBeforeGoldenSpins;
    let coins = data.coins;
    let goldenSpins = data.goldenSpins;
    let goldenSpinsMeterAtEnd = data.goldenSpinsMeterAtEnd;
    let winAmountSoFar = data.winAmountSoFar;

    this.addFSSpinDataToQueue(
      spinEvent,
      coinAwardsAfterGoldenSpins,
      coinAwardsBeforeGoldenSpins,
      coins,
      goldenSpins,
      goldenSpinsMeterAtEnd,
      winAmountSoFar,
      anticipationTriggered
    );
  }

  if (payWays && payWays.winAmount > 0) {
    this.addWinningsToQueue(payWays);
  }
  if (data.coinAwards && data.coinAwards.coins.length > 0) {
    this.addCoinResult(data.coinAwards);
  } else if (data.coinAwardsAfterGoldenSpins && data.coinAwardsAfterGoldenSpins.winAmount > 0) {
    this.addCoinResult(data.coinAwardsAfterGoldenSpins);
  } else if (data.coinAwardsBeforeGoldenSpins && data.coinAwardsBeforeGoldenSpins.winAmount > 0) {
    this.addCoinResult(data.coinAwardsBeforeGoldenSpins);
  } else if (data.goldenSpins && data.goldenSpins.winAmount > 0) {
    this.addCoinResult(data.goldenSpins);
  }

  if (freeSpinsActive) {
    this.fsWinnings += data.winAmount;

    if (data.spinsAdded !== 0) {
      this.addRetriggerToQueue(data.spinsAdded);
    }

    if (this.fsCount < this.freeSpins.length) {
      this.addFSDataToQueue();
    } else {
      this.addFSEndToQueue(this.fsWinnings, data, isCapped);
      this.addGameCompleteToQueue(this.fsWinnings);

      let gcMessage = this._messageQueue[this._messageQueue.length - 1];
      gcMessage.persistentValues = this._persistentValues;

      this.inFS = false;
    }

    cb();
    this.triggerNextMessage();
  } else {
    return spinEvent.totalWinnings;
  }
};

GatiServerGame.prototype.swapSymbolsForSizedVariants = function (spinEvent, coins) {
  const fishSymbolThresholds = [
    { min: 0, max: 3, id: 0 },
    { min: 3, max: 4, id: 1 },
    { min: 5, max: 6, id: 2 },
    { min: 8, max: 10, id: 3 },
    { min: 15, max: 20, id: 4 },
    { min: 25, max: Infinity, id: 5 },
  ];

  const fishSymbolMapOffsetToID = {
    0: 100,
    1: 106,
    2: 112,
    3: 118,
    4: 124,
  };

  const self = GatiServer.prototype;
  for (let x = 0; x < spinEvent.reelList.length; x++) {
    const reel = spinEvent.reelList[x].symbols;
    for (let y = 0; y < reel.length; y++) {
      // IF IT'S A "COIN" (FISH SYMBOL IN RAPID RICHES)
      if (reel[y].value === 18) {
        let baseStake;

        if (!gameData.inReplayOrWatch) {
          baseStake = gameController.globalHelperGetCurrentModeStake(true);
        } else {
          if (gameData.bonusRecovery) {
            baseStake = gameData.recoveryStake;
          } else {
            baseStake = gameData.previousStakeAndMode?.previousBasicStake;
          }
        }

        // get coin (fish) cash value
        const cashValue = coins.find((coin) => coin.coord.reel === x && coin.coord.row === y).amount;

        // get multiplier froms take
        const multiplier = cashValue / baseStake;

        // get the fish symbol threshold (used to decide what id of what fish symbol to use)
        const cashID = fishSymbolThresholds.find(
          (threshold) => multiplier >= threshold.min && multiplier <= threshold.max
        ).id;

        const symbolIdOffset = reel.length - 3;

        const newSymbolID = fishSymbolMapOffsetToID[symbolIdOffset] + cashID;

        reel[y].value = newSymbolID;
      } else {
        let symbolIDOffset = reel.length - 3;
        if (x === 0 || x === spinEvent.reelList.length - 1) {
          symbolIDOffset = 2;
        }
        reel[y].value += symbolIDOffset * 20;
      }
    }
  }
};

GatiServerGame.prototype.getSpinDataNormal = function (data) {
  let spinEvent = data.stopWindow;
  let winningLinesEvent = data.payWays;

  if (!this.validateResponse(spinEvent)) return;
  if (!this.validateResponse(winningLinesEvent)) return;

  this.getSpinDataGeneric(spinEvent, data, false, function () {});
};

GatiServerGame.prototype.getSpinDataFS = function (data, cb) {
  let thisFsOutcome = this.freeSpins[this.fsCount++];
  let spinEvent = thisFsOutcome.stopWindow;

  let spinWin = 0;
  spinWin += thisFsOutcome.winAmount;
  this.fsWinnings += spinWin;

  this.getSpinDataGeneric(spinEvent, thisFsOutcome, true, cb);
};

GatiServerGame.prototype.addFSAwardToQueue = function (freespinsAwarded) {
  var message = {};
  message.type = "spinner:FreeSpinsAwardEvent";
  message.freeSpinsAwarded = freespinsAwarded;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addRetriggerToQueue = function (count) {
  let message = {};
  message.type = "spinner:FreeSpinsRetriggerEvent";
  message.num = count;
  this._messageQueue.push(message);
};

// The cheat format for this game has changed to accommodate the game state, to:

// {"s":"", r:[]}

// A new property has been added to client data response:

// "repro": ""

// Note "repro" is only set if "cheat" is set in the request, this is to ensure
// "repro" is only set in the development environment. For games where no cheat
// is beint sent send json null to the server to activate "repro"

// e.g:
//     cheat = JSON.stringify(null);

// This should simplify building cheats. You can use this string in cheatfinder tool
// and also print it to the browser console.

GatiServer.prototype.getCheatString = function () {
  return this.force;
};

GatiServer.prototype.logCheatString = function () {
  this.force = this._latestEngineReponse.wager.bets[0].eventdata.response.clientData.Repro;

  if (this.force !== "") {
    console.log("force: " + this.force);
  }
};

GatiServer.prototype.updateInitialPlayerStateFromCheatString = function () {
  if (this.initialPlayerState !== undefined && this.cheat !== "null") {
    const force = JSON.parse(this.force);
    const respins = parseInt(force.s.match(/R(\d+)/)[1], 10);
    const coins = parseInt(force.s.match(/A(\d+)/)[1], 10);
    const initialPlayerState = JSON.parse(this.initialPlayerState.state);

    if (
      initialPlayerState.CloverProgress[this.currentMode] &&
      initialPlayerState.CloverProgress[this.currentMode][this._stake]
    ) {
      initialPlayerState.CloverProgress[this.currentMode][this._stake].RespinsCount = respins;
      initialPlayerState.CloverProgress[this.currentMode][this._stake].ActivationCount = coins;
    }
    this.initialPlayerState.state = JSON.stringify(initialPlayerState);
    this.restoreCounterData(this.initialPlayerState);
  }
};

GatiServer.prototype.addCheatToRequest = function (request, forces) {
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  request.cheat = forces;
};

GatiServer.prototype.updateForces = function (forces) {
  if (!forces) return undefined;
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  return forcesJson;
};

GatiServerGame.prototype.isGameModeBonusBuy = function (mode) {
  return mode === "BONUS_BUY_LOW" || mode === "BONUS_BUY_MEDIUM" || mode === "BONUS_BUY_HIGH";
};
